import React, {useContext, useEffect, useState} from "react";
import {FormattedMessage} from "react-intl";
import "./OtherSubPageMenu.css";
import {Link, LinkProps, useLocation} from "react-router-dom";
import {Applications} from "./Applications";
import {NavigationManagement} from "../LandingPage";
import {ConnectorOverview} from "./ConnectorOverview";
import {AppSettingsContext} from "../utility/AppSettingsProvider";
import {keycloak} from "../utility/KeycloakProvider";

type RoleArray = ("DM Mitglied" | "DM Administration")[];

/**
 * Lists links to various sub-pages or to external sites
 */
function OtherSubPageMenu(props: {navigationManagement: NavigationManagement}) {
  const {grafanaUrl} = useContext(AppSettingsContext);
  const location = useLocation();
  const [currentSubPage, setCurrentSubPage] = useState("");

  const link = window.location.origin + "/datamarket/other/";
  const subPages: Record<string, {to?: string; roles: RoleArray}> = {
    applications: {roles: ["DM Administration"]},
    connectors: {roles: ["DM Administration"]},
    log_dashboard: {to: grafanaUrl, roles: ["DM Administration"]},
  };

  useEffect(() => {
    setCurrentSubPage(window.location.pathname.split("/")[3]);
  }, [location]);

  useEffect(() => {
    if (props.navigationManagement.isTryingToNavigate.length === 0) return;

    props.navigationManagement.allowNavigation();
  }, [props.navigationManagement.isTryingToNavigate]);

  if (
    currentSubPage &&
    currentSubPage in subPages &&
    !subPages[currentSubPage].to
  ) {
    const allowedRoles = subPages[currentSubPage].roles;
    if (!allowedRoles.some((role) => keycloak.hasResourceRole(role)))
      return (
        <div className="landingPageGrid landingPageUnauthorized">
          <p>
            <FormattedMessage id="landingPage.unauthorized" />
          </p>
        </div>
      );
    return {
      applications: <Applications />,
      connectors: <ConnectorOverview />,
    }[currentSubPage];
  }

  return (
    <div className="otherSubPageMenu landingPageGrid">
      <h1>
        <FormattedMessage
          id="otherSubPageMenu.title"
          values={{b: (chunks) => <b>{chunks}</b>}}
        />
      </h1>
      {Object.keys(subPages).map((page) => {
        if (
          !subPages[page].roles.some((role) => keycloak.hasResourceRole(role))
        )
          return null;
        const linkProps: LinkProps = subPages[page].to
          ? {to: subPages[page].to || "", target: "_blank", rel: "noreferrer"}
          : {to: link + page};
        return (
          <div className="otherSubPageMenuLink" key={page}>
            <Link id={page + "TileLink"} {...linkProps}>
              <div>
                <FormattedMessage id={"otherSubPageMenu." + page} />
              </div>
            </Link>
          </div>
        );
      })}
    </div>
  );
}

export {OtherSubPageMenu};
